import HubCore from 'hub-js'

const dataCore = {
  environment: process.env.VUE_APP_CORE_ENV,
  theme: process.env.VUE_APP_THEME
}
const hubInstance = new HubCore(dataCore)

const getters = {
  getAppByKey: (state) => (id) => state.apps.items.filter(e => e.public_app_key === id),
  getDescriptionByLang: (state) => (lang) => state.detail.descriptions.filter(e => e.language === lang),
  getBannersImageLink: (state) => (banners) => banners.map(banner => hubInstance.image.listById(banner)),
  getAvatarImageLink: (state) => (avatar) => hubInstance.image.listById(avatar),
  getEventsStatus: (state) => () => state.detail.events.concat(state.detail.optional_events),
  getActionsStatus: (state) => () => state.detail.actions.concat(state.detail.optional_actions)
}

export default getters
